import memoize from '@emotion/memoize'
import DOMPurify from 'dompurify'

/**
 * Check if value is number
 *
 * @param  {[type]}  n
 * @return {Boolean}
 */
export function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n)
}

/**
 * Santizes error messages for XSS potential vulnerabilities
 * @param str String to sanitize
 * @returns {string}
 */
export const sanitize = memoize((str) => DOMPurify.sanitize(str))

/**
 * Get error message from api response error
 * @param err Error from response
 * @param fallbackMessage Fallback message if there is no error response
 * @returns {string}
 */
export function messageFromResponseError(err, fallbackMessage = '') {
  return err &&
    err.response &&
    err.response.data &&
    typeof err.response.data === 'string'
    ? err.response.data
    : fallbackMessage
}

export function scrollToTopOfResults(wrapperRef) {
  const bodyRect = document.body.getBoundingClientRect()
  const elementRect = wrapperRef.current.getBoundingClientRect()

  window.scrollTo({
    top: elementRect.top - bodyRect.top,
    behavior: 'smooth'
  })
}

const ADMIN_ROLE = 'ADMIN'
const DEV_ROLE = 'DEV'
const BOOTCAMP_ROLE = 'BOOTCAMP_ORGANIZER'

export function hasSupportAppPermission(session) {
  let adminTeam = session?.teams?.some((team) =>
    // Teams with support app access
    [
      '9060778c-be28-5052-ac55-762b5fe4fbfb', // Advocacy
      '8dde656c-505e-5bfa-958a-23fa70040acc', // Sales
      'be77f7cd-9272-5072-98d5-f03f402c96b3', // Security
      '51823ecb-9c44-526b-80d2-79b128559185', // Success
      '616d8e8d-46f0-5cfe-aa5e-f7b6fb0c4c6e', // Product
      '4b420303-d500-5d13-8e62-980348125226', // Management
      'dc878f18-4cbf-558a-b2e4-26ede3e92221', // Marketing
      'a8d2b852-21a9-50c1-adf5-de89a507e859', // Professional Services
      '5e07f9ed-cd53-5bee-96fb-3220ddc5318e', // Support
      'e7352a6b-a9a0-513c-81e4-980f680a70c2' // Engineering (Gremlin Inc.)
    ].some((id) => id === team.identifier)
  )
  let adminRole = session?.roles?.some(
    (r) => r === ADMIN_ROLE || r === DEV_ROLE || r === BOOTCAMP_ROLE
  )
  return adminRole && adminTeam
}
